import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-standart-tabs-head',
  templateUrl: './standart-tabs-head.component.html',
  styleUrls: ['./standart-tabs-head.component.css']
})
export class StandartTabsHeadComponent implements OnInit {

  flag = true;
  constructor() { }

  ngOnInit() {
  }

  change(data) {
    this.flag = data;
  }
  
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/standart-tabs-head/standart-tabs-head.component.ts